<p-toast >
  <ng-template let-message pTemplate="message">
    <div class="p-flex p-flex-column" style="flex: 1">
        <div class="p-text-center">
            <i *ngIf="message.severity === 'success'" class="pi pi-check" style="font-size: 3rem"></i>
            <i *ngIf="message.severity === 'error'" class="pi pi-times" style="font-size: 3rem"></i>
            <h5>{{message.summary}}</h5>
            <p>{{message.detail}}</p>
        </div>
    </div>
</ng-template>
</p-toast>
